export const OtpPurpose = {
  ACCOUNT_DELETE: "accountDelete",
  ACCOUNT_LOGIN: "login",
};